import React, { useState, useRef } from 'react';
import dayjs from 'dayjs';
import qs from 'qs';
import {
  Button,
  TextField,
  Box,
  useTheme,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { history, useIntl, useLocation } from 'umi';
import { useSelector, useDispatch } from 'dva';
import AntdTable from '@/components/AntdTable/AntdTable';
import { OPT_ADD, OPT_EDIT, OPT_DETAIL } from '@/constants';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import webStorage from '@/utils/storageManager';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import {
  NOT_START,
  END,
  STOP,
  APPROVE,
  DELETE,
  UNDER_WAY,
} from '../../constants';
import { createOid } from '@/utils/eventtracing';
import ResultListStyled from './ResultListStyled';

const ResultList = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const theme = useTheme();
  const location = useLocation();
  const { ACTIVITY_LOTTERY_STATUS } = webStorage.get('DICTOBJ') || {};
  const TENANT_ID_DALIAN = webStorage.get('TENANT_ID') === '6679';
  const MENU_MARKETING_LOTTERY_EDIT = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_MARKETING_LOTTERY_EDIT');
  const MENU_MARKETING_LOTTERY_DETAIL = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_MARKETING_LOTTERY_DETAIL');
  console.log({ MENU_MARKETING_LOTTERY_DETAIL });
  const { query, pathname } = location;
  const { pageData } = props;
  const { handlePageChange } = props;
  const probabilityRef = useRef();
  //关于弹窗开关

  //关于操作按钮二次弹出确认框
  const [openDialog, setOpenDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  //修改概率框
  const [probabilityOpen, setProbabilityOpen] = useState(false);
  //保存概率输入
  const [probabilityValue, setProbabilityValue] = useState();
  const [chooseRowData, setChooseRowData] = useState(null);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const actionList = [
    {
      type: STOP,
      dialogTitle: '终止',
      dialogContent: '确定要终止该活动吗',
    },
    {
      type: APPROVE,
      dialogTitle: '审核',
      dialogContent: '确定要通过审核吗？',
    },
    {
      type: DELETE,
      dialogTitle: '删除',
      dialogContent: '确定要删除该活动吗？',
    },
  ];

  const loadingEffect = useSelector((state) => state.loading);
  const listLoading = loadingEffect.effects['luckyDraw/getDrawList'];

  const { data: drawList, total } =
    useSelector((state) => state.luckyDraw?.drawList) || {};

  const handleClickQr = (id) => {
    history.push({
      pathname: '/marketing/luck_draw_view/qr_code',
      query: {
        id: String(id),
        pathType: '2',
        sourceType: '3',
      },
    });
  };

  const handleToBenefitVoucher = (type, id, campaignStatus, sourceOid) => {
    const path = {
      [OPT_ADD]: '/marketing/luck_draw_view/luck_draw_view_setting_add',
      [OPT_EDIT]: '/marketing/luck_draw_view/luck_draw_view_setting_edit',
      [OPT_DETAIL]: '/marketing/luck_draw_view/luck_draw_view_setting_detail',
    };
    history.push({
      pathname: path[type],
      query: {
        opt: type,
        id: String(id),
        campaignStatus: campaignStatus === 'UNDER_WAY' ? 1 : '',
        sourceOid,
      },
    });
  };

  //删除
  const handleClickDelete = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'luckyDraw/activityDelete',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '删除成功',
              title: '成功',
            });
            const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
            history.replace(
              `${pathname}?${qs.stringify({
                ...query,
                refreshTime,
              })}`,
            );
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };

  //处理活动暂停
  const handleClickStop = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'luckyDraw/activityPause',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '终止成功',
              title: '成功',
            });
            const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
            history.replace(
              `${pathname}?${qs.stringify({
                ...query,
                refreshTime,
              })}`,
            );
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };
  //换页
  const changePage = ({ pageNum, pageSize }) => {
    handlePageChange({ ...pageData, pageNum, pageSize });
  };

  //新建二维码分组自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
          marginTop: '-8px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseProbabilityDialog}
          color="secondary"
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
        >
          取消
        </Button>
        <Button
          data-log={JSON.stringify({
            oid: createOid('ev'),
            events: ['_ev'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
            virtualParentNode: {
              key: 'test_key_1',
              oid: createOid('ev'),
              events: ['_ev', '_ed'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            },
          })}
          ref={probabilityRef}
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveProbabilityDialog}
          startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
        >
          修改
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const onCloseProbabilityDialog = () => {
    setProbabilityOpen(false);
  };
  //修改概率保存
  const onSaveProbabilityDialog = () => {
    if (
      !probabilityValue ||
      Number(probabilityValue) > 100 ||
      Number(probabilityValue) <= 0
    ) {
      window.message.toast({
        type: 'warning',
        message: '请输入大于0且小于等于100的数字',
        title: '提醒',
      });
      return;
    }
    dispatch({
      type: 'luckyDraw/changeHitRate',
      payload: {
        values: {
          id: chooseRowData.id,
          hitRate: probabilityValue,
        },
      },
      callback: (res) => {
        console.log('probabilityRef', probabilityRef.current);
        window.NE_DAWN.trigger(probabilityRef.current, {
          event: '_ec', // 事件名
          params: { id: chooseRowData.id, hitRate: probabilityValue }, // 事件公参
        });
        if (res.code === 0) {
          setProbabilityOpen(false);
          window.message.toast({
            type: 'success',
            message: '修改成功',
            title: '成功',
          });
          const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
          history.replace(
            `${pathname}?${qs.stringify({
              ...query,
              refreshTime,
            })}`,
          );
        }
      },
    });
  };

  //编辑群组content
  const groupEditContent = () => {
    return (
      <Box width="405px">
        <Box
          style={{
            fontWeight: '400',
            color: '#000',
            fontSize: '18px',
            lineHeight: '25px',
            marginBottom: '8px',
          }}
        >
          {chooseRowData?.name}中奖率修改为
        </Box>
        <Box
          sx={{ display: 'flex', gap: '0 4px' }}
          className="text-input-align-style"
        >
          <TextField
            sx={{ width: '149px' }}
            id="standard-basic"
            label=""
            variant="standard"
            value={probabilityValue}
            onChange={(e) => {
              const value = e.target.value;
              if (!isNaN(value) && value >= 0) {
                setProbabilityValue(e.target.value);
              }
            }}
            onBlur={(e) =>
              setProbabilityValue(
                e.target.value.match(/^-?\d+(?:\.\d{0,2})?/)?.[0],
              )
            }
          />
          <Box
            style={{
              fontWeight: '400',
              color: '#000',
              fontSize: '16px',
              lineHeight: '24px',
              paddingTop: '3px',
            }}
          >
            %
          </Box>
        </Box>
      </Box>
    );
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 216,
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      width: 216,
    },
    {
      title: '活动时间',
      dataIndex: 'beginDateTime',
      key: 'beginDateTime',
      width: 216,
      render: (_, { beginDateTime, endDateTime }) => {
        const beginDate = dayjs(beginDateTime).format('YYYY-MM-DD');
        const endDate = dayjs(endDateTime).format('YYYY-MM-DD');
        return `${beginDate} ~ ${endDate}`;
      },
    },
    {
      title: '中奖概率',
      dataIndex: 'hitRate',
      key: 'hitRate',
      width: 216,
      render: (_, { hitRate }) => {
        return `${hitRate?.toFixed(2)}%`;
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 216,
      render: (_, { status }) => {
        return ACTIVITY_LOTTERY_STATUS?.find((i) => i.dictCode === status)
          ?.nameZh;
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 232,
      render: (_, rowInfo) => {
        const id = rowInfo.id;
        const status = rowInfo.status;
        const canEdit = status !== END; //可以编辑
        const canEditProbability = status !== END; //可以修改概率
        const canStop = status !== END; //可以终止
        const canDownLoad = status !== NOT_START; //可以下载
        const canDelete = status !== UNDER_WAY; //可以删除

        return (
          <div className="handle_btn">
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                sx={{ padding: 0 }}
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_lottery_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (canEdit && MENU_MARKETING_LOTTERY_EDIT) {
                    handleToBenefitVoucher(
                      OPT_EDIT,
                      id,
                      status,
                      'btn_marketing_activity_lottery_list_edit',
                    );
                  }
                }}
                // disabled
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={
                    canEdit && MENU_MARKETING_LOTTERY_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  // fill={theme.palette.secondary.disabled}
                  className={
                    (!canEdit || !MENU_MARKETING_LOTTERY_EDIT) && 'no-drop'
                  }
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
              <IconButton
                sx={{ padding: 0 }}
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_lottery_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  MENU_MARKETING_LOTTERY_DETAIL &&
                    handleToBenefitVoucher(
                      OPT_DETAIL,
                      id,
                      status,
                      'btn_marketing_activity_lottery_list_details',
                    );
                }}
                // disabled
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={
                    MENU_MARKETING_LOTTERY_DETAIL
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  // fill={theme.palette.secondary.disabled}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>

            <ButtonTip title="终止">
              <IconButton
                sx={{ padding: 0 }}
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_lottery_list_terminate',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (canStop && MENU_MARKETING_LOTTERY_EDIT) {
                    handleClickStop(id, STOP);
                  }
                }}
                // disabled
              >
                <SvgIconML
                  name="stop"
                  size={24}
                  fill={
                    canStop && MENU_MARKETING_LOTTERY_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  // fill={theme.palette.secondary.disabled}
                  className={
                    (!canStop || !MENU_MARKETING_LOTTERY_EDIT) && 'no-drop'
                  }
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="修改">
              <IconButton
                sx={{ padding: 0 }}
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_lottery_list_edit_win_probability',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (canEditProbability && MENU_MARKETING_LOTTERY_EDIT) {
                    setChooseRowData(rowInfo);
                    setProbabilityOpen(true);
                    setProbabilityValue(rowInfo.hitRate);
                  }
                }}
                // disabled
              >
                <SvgIconML
                  name="icon-modify"
                  size={24}
                  fill={
                    canEditProbability && MENU_MARKETING_LOTTERY_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  // fill={theme.palette.secondary.disabled}
                  className={
                    (!canEdit || !MENU_MARKETING_LOTTERY_EDIT) && 'no-drop'
                  }
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="数据">
              <IconButton
                sx={{ padding: 0 }}
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_lottery_list_data',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  // canDownLoad && handDownLoad(id);
                  if (canDownLoad && MENU_MARKETING_LOTTERY_DETAIL) {
                    history.push({
                      pathname:
                        '/marketing/luck_draw_view/luck_draw_view_report',
                      query: {
                        id,
                        status,
                      },
                    });
                  }
                }}
              >
                <SvgIconML
                  name="data-icon"
                  size={24}
                  fill={
                    canDownLoad && MENU_MARKETING_LOTTERY_DETAIL
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={
                    (!canDownLoad || !MENU_MARKETING_LOTTERY_DETAIL) &&
                    'no-drop'
                  }
                />
              </IconButton>
            </ButtonTip>
            {TENANT_ID_DALIAN && (
              <ButtonTip title="小程序码">
                <IconButton
                  sx={{ padding: 0 }}
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  onClick={() => {
                    canEdit && handleClickQr(id);
                  }}
                >
                  <SvgIconML
                    name="couponImg"
                    size={24}
                    // fill={theme.palette.primary.main}
                    fill={
                      canEdit
                        ? theme.palette.primary.main
                        : theme.palette.secondary.disabled
                    }
                    className={!canEdit && 'no-drop'}
                  />
                </IconButton>
              </ButtonTip>
            )}
            <ButtonTip title="删除">
              <IconButton
                sx={{ padding: 0 }}
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_lottery_list_delete',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                // 删除
                onClick={() => {
                  MENU_MARKETING_LOTTERY_EDIT &&
                    canDelete &&
                    handleClickDelete(id, DELETE);
                }}
                // disabled
              >
                <SvgIconML
                  name="circleDelete"
                  size={24}
                  fill={
                    canDelete && MENU_MARKETING_LOTTERY_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  // fill={theme.palette.secondary.disabled}
                  className={
                    (!canDelete || !MENU_MARKETING_LOTTERY_EDIT) && 'no-drop'
                  }
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];
  return (
    <ResultListStyled id="table-wrapper-dom">
      <AntdTable
        dataSource={drawList}
        columns={columns}
        loading={listLoading}
        pagination={false}
        changePage={changePage}
        page={pageData}
        data={drawList}
        devicesMinWidth={1640}
        total={total}
        id="table-wrapper-dom"
      />
      <DialogDataML
        open={openDialog}
        title={currentAction?.dialogTitle}
        content={currentAction?.dialogContent}
        handleClose={handleCloseDialog}
        handleConfirm={currentAction?.confirm}
      ></DialogDataML>
      <DialogDataML
        open={probabilityOpen}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span
              style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
            >
              编辑中奖概率
            </span>
          </Box>
        }
        content={groupEditContent()}
        handleClose={onCloseProbabilityDialog}
        button={initButton()}
      />
    </ResultListStyled>
  );
};
export default ResultList;
